const pdfLightboxTriggers = document.querySelectorAll('.ig-lightbox-book-container');
let assetsLoadingPromise = null;

pdfLightboxTriggers.forEach(triggerElement => {
    triggerElement.addEventListener('click', async (e) => {
        e.preventDefault();
        if (triggerElement.pdfToLightBoxConverterInstance) {
            triggerElement.pdfToLightBoxConverterInstance.open();
            return;
        }
        triggerElement.classList.add('loading');
        const assetData = triggerElement.dataset.assets;

        try {
            if (typeof PdfToLightBoxConverter === 'undefined') {
                if (!assetsLoadingPromise) {
                    assetsLoadingPromise = loadAssets(assetData);
                }
                await assetsLoadingPromise;
            }
            triggerElement.pdfToLightBoxConverterInstance = new PdfToLightBoxConverter({
                container: triggerElement,
                source: triggerElement.href
            });
            triggerElement.pdfToLightBoxConverterInstance.open();

        } catch (error) {
            console.error('Failed to load assets:', error);
            assetsLoadingPromise = null;
        } finally {
            triggerElement.classList.remove('loading');
        }
    });
});

async function loadAssets(assetData) {
    const { css } = JSON.parse(assetData);
    const cssPromises = css.map(url => {
        return new Promise((resolve, reject) => {
            if (document.querySelector(`link[href="${url}"]`)) return resolve();
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            link.onload = resolve;
            link.onerror = reject;
            document.head.appendChild(link);
        });
    });
    let js = [
        '@internetgalerie/ig-flipbook/IgFlipbook.lazy.js',
        '@internetgalerie/ig-flipbook/pdf_js/pdf.min.mjs',
        '@internetgalerie/ig-flipbook/pdf_js/pdf.worker.min.mjs'
    ];
    const jsPromises = js.map(url => import(url));
    return Promise.all([...cssPromises, ...jsPromises]);
}